import React, {forwardRef} from 'react';

const PostSubmissionScrollPoint = forwardRef((props, ref) => {
  return <div ref={ref} />;
});

export default PostSubmissionScrollPoint;
